
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import Routes from "./Routes"

// ReactDOM.render(<Routes />, document.getElementById("root"));
createRoot(document.getElementById('root')).render(<Routes />);

